import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './Quote.css';

import { AccordionItem } from '../../components/common/CartAccordion';
import MyProduct from '../../components/common/MyProduct';
import { calculateFinalUnitPrice, formatUSD } from '../../helpers/formatterHelper';

export default function OriginalQouteRequest({ quote, typicalLayouts, label }) {

    const [typicalLayoutSubtotals, setQuoteTypicalSubtotals] = useState([]);
    const [estimatedCost, setEstimatedCost] = useState(0);
    const [miscSubTotals, setMiscSubTotals] = useState(0);
    const [totalQuantity, setTotalQuantity] = useState(0);      
   
    useEffect(() => {
        //get subtotals for all typical layouts
        if (typicalLayouts != null) {
            var subtotals = [];
            typicalLayouts.map((group) => {
                const typicalProducts = typicalLayouts.products.filter(item => item.typicalLayoutItemId == group.id);
                const products = quote.products.filter(a => typicalProducts.filter(b => a.quoteItemId == b.cartItemId).length > 0);
                const subtotal = products.reduce((total, product) => total + (calculateFinalUnitPrice(product) * product.quantity), 0);
                const productsQuantity = products.reduce((total, product) => total + product.quantity, 0);
                subtotals.push({ id: group.id, subtotal: subtotal * group.quantity, quantity: group.quantity, productsQuantity: productsQuantity });
            });
            setQuoteTypicalSubtotals(subtotals);
        } else {
            setQuoteTypicalSubtotals([]);
        }
    }, [typicalLayouts]);


    useEffect(() => {
        //calculate total estimate
        if (quote && quote.products) {

            //filter out any products that belong to a typical layout
            const items = typicalLayouts ? quote.products.filter(a => typicalLayouts.products.filter(b => b.cartItemId == a.quoteItemId).length == 0) : quote.products;

            //get subtotal of all typical layouts
            const typicalSubtotals = typicalLayoutSubtotals && typicalLayoutSubtotals.length > 0 ?
                typicalLayoutSubtotals.reduce((sum, item) => sum + item.subtotal, 0) : 0;

            //get subtotal of miscellaneous items
            const subtotal = items.reduce((sum, productItem) =>
                sum + calculateFinalUnitPrice(productItem) * productItem.quantity, 0);

            //get quantity of typical layout products
            var typicalQuantities = 0;
            if (typicalLayouts != null) {
                typicalLayouts.map((group) => {
                    const tItems = typicalLayouts ? quote.products.filter(a => typicalLayouts.products.filter(b => b.typicalLayoutItemId == group.id && b.cartItemId == a.quoteItemId).length > 0) : [];
                    typicalQuantities += (group.quantity * tItems.reduce((sum, item) => sum + item.quantity, 0));
                });
            }

            //get quantity of miscellaneous products
            const quantity = items.reduce((sum, item) => sum + item.quantity, 0);

            setMiscSubTotals(subtotal);
            setEstimatedCost(subtotal + typicalSubtotals);
            setTotalQuantity(typicalQuantities + quantity);
        }

    }, [quote, typicalLayoutSubtotals, typicalLayouts]);     
      

    const handleTypicalLayoutLabelUpdate = (id, label) => {
        if (id != null && label != '') {
            console.log(id, label);
        }
    }

    const handleTypicalLayoutQuantityUpdate = (id, quantity) => {
        if (id != null && quantity != null && quantity > 0) {
            console.log(id, quantity);
        }
    }
    const handleDeleteTypicalLayout = (id) => {
        if (id != null) {
            console.log(id);
        }
    }

    
    const filteredQuoteProducts = quote.products.filter(item => typicalLayouts && typicalLayouts.products.filter(a => a.cartItemId == item.quoteItemId).length == 0 || !typicalLayouts);


    if (quote?.info?.districtId === 0) {
        return '';
    }
   
    return (
        <div className="project-wrap">
            <div className="project-item">
                <div className="project-item-inner">
                    <p className="project-item-title">
                        {quote.info.districtId > 0 &&
                            <>{label} #{quote.info.districtId + '-' + ("000" + quote.info.id).slice(-4)} ({totalQuantity} Items)</>
                        }
                    </p>
                    {totalQuantity > 0 ? (
                        <div>

                            {typicalLayouts && typicalLayouts.map((group) => {
                                const typicalProducts = typicalLayouts.products.filter(item => item.typicalLayoutItemId == group.id);
                                const subtotal = typicalLayoutSubtotals && typicalLayoutSubtotals.length > 0 && typicalLayoutSubtotals.filter(a => a.id == group.id).length > 0
                                    ? typicalLayoutSubtotals.filter(a => a.id == group.id)[0].subtotal : 0;
                                return (
                                    <AccordionItem
                                        typicalLayout={group}
                                        title={group.label}
                                        quantity={group.quantity}
                                        subtotal={subtotal}
                                        opened={true}
                                        key={'typical_layout ' + group.id}
                                        typicalLayoutItemId={group.id}
                                        updateLabel={handleTypicalLayoutLabelUpdate}
                                        updateQuantity={handleTypicalLayoutQuantityUpdate}
                                        deleteTypicalLayout={handleDeleteTypicalLayout}
                                        isQuote={true}
                                    >
                                        <div className="my-product-title-table">
                                            <div className="my-product-title-row">
                                                <div className="my-product-title-coll">
                                                    &nbsp;
                                                </div>
                                                <div className="my-product-title-coll product-details-title">
                                                    Product Details
                                                </div>
                                                <div className="my-product-title-coll product-tag">
                                                    Tag
                                                </div>
                                                <div className="my-product-title-coll product-quantity">
                                                    Quantity
                                                </div>
                                                <div className="my-product-title-coll unit-price">
                                                    <span className="table-cellprice">
                                                        Unit Price
                                                    </span>
                                                    <span className="table-cell-totalammount">
                                                        Total
                                                    </span>
                                                </div>
                                            </div>
                                            {typicalProducts.map(typicalProduct => quote.products.filter(product => product.quoteItemId == typicalProduct.cartItemId).map(item => {
                                                return (<MyProduct key={item.quoteItemId} product={item} buttons={{ delete: false, wishlist: false }} canEdit={false} canViewProductDetail={true} isTypicalLayout={true} />);
                                            }))}
                                        </div>
                                    </AccordionItem>
                                );
                            })}

                            {filteredQuoteProducts != null && filteredQuoteProducts.length > 0 &&
                                <>
                                    {typicalLayouts && typicalLayouts.length > 0 ?
                                        <AccordionItem
                                            title={"Miscellaneous"}
                                            opened={true}
                                            key={'miscellaneous'}
                                            isMisc={true}
                                            subtotal={miscSubTotals}
                                            isQuote={true}
                                        >
                                            <div className="my-product-title-table">
                                                <div className="my-product-title-row">
                                                    <div className="my-product-title-coll">
                                                        &nbsp;
                                                    </div>
                                                    <div className="my-product-title-coll product-details-title">
                                                        Product Details
                                                    </div>
                                                    <div className="my-product-title-coll product-tag">
                                                        Tag
                                                    </div>
                                                    <div className="my-product-title-coll product-quantity">
                                                        Quantity
                                                    </div>
                                                    <div className="my-product-title-coll unit-price">
                                                        <span className="table-cellprice">
                                                            Unit Price
                                                        </span>
                                                        <span className="table-cell-totalammount">
                                                            Total
                                                        </span>
                                                    </div>
                                                </div>
                                                {filteredQuoteProducts.map((item) => (
                                                    <MyProduct key={item.quoteItemId} product={item} buttons={{ delete: false, wishlist: false }} canEdit={false} canViewProductDetail={true} isTypicalLayout={false} />
                                                ))}
                                            </div>
                                        </AccordionItem>
                                        :
                                        <div className="my-product-title-table">
                                            <div className="my-product-title-row">
                                                <div className="my-product-title-coll">
                                                    &nbsp;
                                                </div>
                                                <div className="my-product-title-coll product-details-title">
                                                    Product Details
                                                </div>
                                                <div className="my-product-title-coll product-tag">
                                                    Tag
                                                </div>
                                                <div className="my-product-title-coll product-quantity">
                                                    Quantity
                                                </div>
                                                <div className="my-product-title-coll unit-price">
                                                    <span className="table-cellprice">
                                                        Unit Price
                                                    </span>
                                                    <span className="table-cell-totalammount">
                                                        Total
                                                    </span>
                                                </div>
                                            </div>

                                            {filteredQuoteProducts.map((item) => (
                                                <MyProduct key={item.quoteItemId} product={item} buttons={{ delete: false, wishlist: false }} canEdit={false} canViewProductDetail={true} isTypicalLayout={false} />
                                            ))}
                                        </div>
                                    }
                                    <div className="cart-layout-wrap">
                                        <div className="cart-grid-row estimate">
                                            <div className="cart-estimate-cell">
                                                <p className="cart-estimate-content">
                                                    Estimated Cost ({totalQuantity}{' '}
                                                    items):{' '}
                                                    <b>{formatUSD(estimatedCost)}</b>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        </div>

    );
}

OriginalQouteRequest.propTypes = {    
    quote: PropTypes.object,
    typicalLayouts: PropTypes.array,
    label: PropTypes.string
};
